module.exports = __webpack_public_path__ + "static/media/Aaron Chen.126e7e4b.jpg";